<template>
  <v-autocomplete
    v-model="prodotto"
    :loading="loading"
    :items="items"
    :search-input.sync="searchProdotto"
    no-data-text="Cerca un prodotto per codice o descrizione"
    :label="item.label"
    :rules="rulesValidation"
    item-text="testo"
    item-value="id"
    clearable
    dense
    hide-details="auto"
    :solo="solo"
    :flat="suTable"
    :outlined="!suTable"
    :return-object="true"
    :disabled="disabled"
    @change="onchange"
    @click:clear="clear"
    v-if="showItem"
  >
<!--     <template v-slot:prepend>
      <v-icon v-if="item.cercaEsterno" @click="onCercaEsterno" title="Cerca il prodotto in un archivio esterno" :disabled="searchDisabled">mdi-folder-search-outline</v-icon>
      <ricerca-esterna :openSearch="openSearch" @importaEsterno="onImportaEsterno"/>
    </template> -->
    <template v-slot:[`selection`]="{ item }">
      {{ suTable ? item.codice : item.codice + ' - ' +  item.descrizione }}
    </template>
    <template v-slot:append-outer>
      <v-icon v-if="!item.addForbidden" color="success" @click="onNuovoArticolo" title="Crea un nuovo prodotto">mdi-archive-plus-outline</v-icon>
    </template>
  </v-autocomplete>
</template>

<script>
  import _ from 'lodash'
  import { validazioni } from '@/mixins/validazioni.js'
  import { sanitize } from '@/helpers/sanitize'
  import prodotti from '@/services/prodottiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  /* import RicercaEsterna from './ricercaEsterna' */

  export default {
    name: 'prodotto',
/*     components: {
      RicercaEsterna
    }, */
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,
      disabled: { type: Boolean, default: false },
      solo: { type: Boolean, default: true },
      updateTrigger: Number,
      index: Number,
      suTable: { type: Boolean, default: false },
      isLotto: { type: Boolean, default: true },
      isBom: { type: Boolean, default: true },
      isProdottoBase: { type: Boolean, default: false },
      clearInfo: Number,
      popolaInfo: Number
    },
    data (vm) {
      return {
      loading: false,
      items: [],
      debounceSearch: null,
      searchProdotto: '',
      prodotto: '',
      bloccaWatch: false,
      newItem: null,
      openSearch: false
      }
    },
    created() {
      this.debounceSearch = _.debounce(this.searchProdottoDeb, 500)
    },
    async mounted() {
      if (this.item && this.item.value) {
        await this.querySelections(this.item.value)
        this.bloccaWatch = true
        this.prodotto = Object.assign({}, this.items[0])
        this.onchange(this.prodotto)
      }
    },
    watch: {
      async searchProdotto(val) {
        if (this.bloccaWatch) {
          this.bloccaWatch = false
          return
        }
        await this.debounceSearch(val)
      },
      prodottiSelezionati() {
        this.searchProdotto = ''
      },
      async updateTrigger() {
        // console.log('update trigger')
        // this.searchProdotto = ''
        this.$forceUpdate()
      },
      clearInfo() {
        // console.log('Clear info prodotto')
        this.searchProdotto = ''
        this.prodotto = null
        this.items = []        
      },
      async popolaInfo() {
        if (this.item && this.item.value) {
          await this.querySelections(this.item.value)
          this.bloccaWatch = true
          this.prodotto = Object.assign({}, this.items[0])
          this.onchange(this.prodotto)
        }
      }
    },
    computed: {
      showItem() {
        if (this.item && this.item.showIf) {
          return _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      },
      searchDisabled() {
        return this.prodotto ? true : false
      }
    },    
    methods: {
      async refresh() {
        if (this.item && this.item.value) {
          await this.querySelections(this.item.value)
          this.bloccaWatch = true
          this.prodotto = Object.assign({}, this.items[0])
          // this.onchange(this.prodotto)
        }
      },
      getDescrizione(item) {
        return `${item.codice} - ${item.descrizione} ${_.get(item, 'variante2.descrizione', '')} ${_.get(item, 'variante1.descrizione', '')}`
      },
      async searchProdottoDeb(val) {
        // TODO: verificare se quello cercato è già presente prima di richiamare
        // const pr = this.prodottiSelezionati.filter(x => x === val)
        // if (val && pr.length === 0) {
        if (val) {
          await this.querySelections(val)
        }
      },
      async querySelections (val) {
        this.loading = true
/*         const filtri = {
          testo: val
        } */
        const filtri = {
          id: val,
          codice: val,
          descrizione: val,
          isLotto: this.isLotto,
          isBom: this.isBom,
          isProdottoBase: this.isProdottoBase
        }
        const opzioni =  {
          itemsPerPage: 20
        }
        const data = await prodotti.getFilteredProducts(filtri, opzioni)
        // const cp = data && data.docs.length > 0 ? data.docs : []
        const cp = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
        this.items = _.uniqBy(cp, 'ricercaTC').map(x => {
          const v1 = _.get(x, 'varianti.variante1', {})
          const v2 = _.get(x, 'varianti.variante2', {})
          return { 
            testo: (`${x.codice} - ${x.descrizione} ${_.get(x, 'varianti.variante2.descrizione', '')} ${_.get(x, 'varianti.variante1.descrizione', '')}`).trim(),
            id: x._id,
            codice: x.codice,
            // descrizione: x.descrizione,
            descrizione: (`${x.descrizione} ${_.get(x, 'varianti.variante2.descrizione', '')} ${_.get(x, 'varianti.variante1.descrizione', '')}`).trim(),
            prezzo: x.prezzo && x.prezzo.L1 && x.prezzo.L1.base, // TODO: Prendere listino di default da configurazione (su store..)
            prezzo2: x.prezzo && x.prezzo.L2 && x.prezzo.L2.base,
            prezzoItem: x.prezzo,
            acquisto: x.magazzino && x.magazzino.prezzoAcquisto,
            variante1: v1,
            variante2: v2,
            datiFiscali: x.datiFiscali || {},
            item: x
          }
        })
        this.loading = false
      },
      onchange(value) {
        if (value) {
          this.searchProdotto = ''
          // this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: this.item.value.id, item: this.item.value })
          this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: this.prodotto.id, item: value, index: this.index })
        }
      },
      clear() {
        this.searchProdotto = ''
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: '', item: null, index: this.index })   
      },
      async onNuovoArticolo() {
/*         const defaultItem = await prodotti.getModello()
        this.$store.commit('prodotti/SET_PRODOTTO', JSON.parse(JSON.stringify(defaultItem))) */
        this.newItem = await prodotti.getModello()
        this.$store.commit('prodotti/SET_PRODOTTO', this.newItem)
        
        this.$store.commit('movimenti/SET_CREA_ARTICOLO')
      },
      async onCercaEsterno() {
        this.openSearch = true
        await this.$nextTick()
        this.openSearch = false
      }      
    }
  }
  // https://stackoverflow.com/questions/46967557/how-do-i-change-font-size-in-vuetify-component
</script>
